import React from 'react';

import AddressBlock from 'Components/AddressBlock';
import Footer from 'Components/Footer';
import GoogleReviews from 'Components/GoogleReviews';
import Header from 'Components/Header';
import WorkerFaq from 'Components/WorkerFaq';
import WorkerHero from 'Components/WorkerHero';
import WorkerKontakt from 'Components/WorkerKontakt';
import WorkerLiving from 'Components/WorkerLiving';
import WorkerOffer from 'Components/WorkerOffer';
import WorkerRecruiter from 'Components/WorkerRecruiter';
import WorkerReviews from 'Components/WorkerReviews';

export default function Worker() {
  return (
    <>
      <Header />
      <WorkerHero bg='bg' overlay='dark' />
      <WorkerOffer showTopOnly={true} bg='black__bgr' overlay='dark' />
      <WorkerLiving bg='bg' overlay='dark' />
      <WorkerReviews bg='black__bgr' overlay='dark' />
      <GoogleReviews bg='bg' overlay='dark' />
      <WorkerRecruiter bg='black__bgr' overlay='dark' />
      <WorkerFaq bg='black__bgr' overlay='dark' />
      <WorkerKontakt bg='bg' overlay='dark' />
      <AddressBlock bg='black__bgr' overlay='dark' />
      <Footer />
    </>
  );
}
